import { render, staticRenderFns } from "./report_dashboard_shell.vue?vue&type=template&id=783ec768&scoped=true&"
import script from "./report_dashboard_shell.vue?vue&type=script&lang=js&"
export * from "./report_dashboard_shell.vue?vue&type=script&lang=js&"
import style0 from "./report_dashboard_shell.vue?vue&type=style&index=0&id=783ec768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783ec768",
  null
  
)

export default component.exports